import { List, ListItem, Toggle } from "konsta/react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";

function Equipment() {
  const dispatch = useAppDispatch();
  const spaJets = useAppSelector((state) => state.app.spaJets);
  const waterfall = useAppSelector((state) => state.app.waterfall);
  const bubblers = useAppSelector((state) => state.app.bubblers);
  const fireBowl = useAppSelector((state) => state.app.fireBowl);
  const spillover = useAppSelector((state) => state.app.spillover);
  return (
    <div>
      <List strong>
        <ListItem
          label
          title="Spa Jets"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={spaJets}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleSpaJets())}
            />
          }
        />
        <ListItem
          label
          title="Waterfall"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={waterfall}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleWaterfall())}
            />
          }
        />
        <ListItem
          label
          title="Bubblers"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={bubblers}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleBubblers())}
            />
          }
        />
        <ListItem
          label
          title="Fire Bowl"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={fireBowl}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleFireBowl())}
            />
          }
        />
        <ListItem
          label
          title="Spillover"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={spillover}
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={() => dispatch(appSlice.actions.toggleSpillover())}
            />
          }
        />
        <ListItem
          label
          title="Party Mode"
          after={
            <Toggle
              component="div"
              className="-my-1"
              checked={
                spaJets && waterfall && bubblers && fireBowl && spillover
              }
              colors={{ checkedBgIos: "bg-green-toggle" }}
              onChange={(e) => {
                const newVal = e.target.checked;
                dispatch(appSlice.actions.setPartyMode(newVal));
              }}
            />
          }
        />
      </List>
    </div>
  );
}

export default Equipment;
